<div class="task-closed rounded px-1">
  <div><strong>Task Closed</strong></div>
  <div>
    @if (task.allCapturesHaveReferral) {
      <p>A valid referral has been collected for this patient.</p>
    }
    @if (!task.allCapturesHaveReferral) {
      <p>No referral has been collected for this patient.</p>
    }
  </div>
</div>
